<template>
   <div class="container px-0 bg-danger">
      <div class="offcanvas offcanvas-end rounded-2 shadow bg-light" 
            data-bs-scroll="true" 
            data-bs-backdrop="false" 
            tabindex="-1" 
            id="offcanvasMention" 
            aria-labelledby="offcanvasMentionLabel"
            @blur="focusOff()"
         >
         <!--
            @blur="focusOff()"
         -->
         <div class="offcanvas-header">
            <h6 id="offcanvasMentionLabel">Mencionar Miembros ({{cnttId}})</h6>
            <button type="button" class="btn-close btn-sm text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref="btn_out_offcanvas"></button>
         </div>
         <hr class="m-0"/>
         <div class="row ">
            <div v-if=" boards.length > 1 " class="col-12">
               <div v-if="boards"
                  class="row row-cols-auto d-flex justify-content-start pt-2 ps-4 pb-1"
                  >
                  <board-rectangle 
                     v-for="(board, index) in boards" :key="index"
                     :board="board"
                     :selected="board.selected"
                     @click="selectedBoard(index)"
                     class="ms-1 pb-1"
                  />
                  <!--
                     @click="selectThisBoard(index)"
                  -->
               </div>
            </div>
         </div>
         <hr v-if=" boards.length > 1 " class="m-0"/>
         <div class="offcanvas-body gap-0 pt-2 mb-scroll">
            <div class="row">
               <b class="tc-d-gray fs-12">Miembros:</b>
            </div>
            <div class="row row-cols-auto p-2">
               <div v-for="(circleUser, index) in usersApp" :key="index" class="col p-0 m-1">
                  <userCircle 
                     :circleUser="circleUser" 
                     class="user-member"
                     @mouseover="showAlias(index)"
                     @mouseleave="clearMember()"
                     @click="addMember(index)"
                     />
               </div>
            </div>
            <div class="hg-mention border border-2 rounded">
               <div class="text-center">
                  {{member.name}}
               </div>
               <div class="text-center">
                  {{member.arroba}}
               </div>

            </div>
         <!--
            <hr class="m-0"/>
                     @click="userYes(index)" 
                     @mouseover="showAlias()"
         -->
         </div>
      </div>
   </div>
</template>

<script>
//import { ref, nextTick, watchEffect } from 'vue';
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

import userCircle from '/src/components/UserCircle.vue';
import BoardRectangle from "./BoardRectangle.vue";

export default {
   components: {
      userCircle,
      BoardRectangle
   },
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const btn_out_offcanvas = ref(null)
      const cellId = ref(0)

      const member = ref({})

      const loading = ref(false)
      const usersApp = ref([])
      const usersToAdd = ref([])
      const userIdsToAdd = ref([])
      const uAppIndex = ref(-1)
      const uAppModule = ref(null)

      const boards = ref([])
      const boardId = ref(null)
      const userId = computed(() => {
         return store.state.auth.user.id;
      })

      onMounted(() => {
         //
         let myOffCanvas = document.getElementById('offcanvasMention')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
            console.log(store.state.wspace.contentId)
            cnttId.value = store.state.wspace.contentId
            let button = event.relatedTarget
            cellId.value = button.getAttribute('data-cell-id')
            //
            member.value = {
               name: '',
               arroba: ''
            }
            //
            //let cmm = document.getElementById('ta-comment').value
            //document.getElementById('ta-comment').value = cmm + '@ @'
            //
            getUsersApp(cnttId.value)
            //
            boardId.value = WspService.getBoardId(store)
            getAllBoards(boardId.value, userId.value, cnttId.value)
            //
            usersToAdd.value = []
            uAppIndex.value = -1
            userIdsToAdd.value = []
            loading.value = false
            //
            myOffCanvas.focus()
            console.log(" show member's OC")
         })
         //
         console.log("member's OC")
      })

      function getUsersApp(contentId) {
         uAppIndex.value = store.state.auth.userAppIndex
         if (uAppIndex.value > -1) {
            uAppModule.value = store.state.auth.userAppModule;

            WspService.getAppMembers(
               uAppModule.value.appModuleComponent[uAppIndex.value].userAppModuleId,
               contentId,
               true)
            .then(response => {
               usersApp.value = response.data
               //console.log(response.data)
            })
            .catch(error => {
               console.log(error);
            });
         }
      }

      function addMember(index) {
         let cmm = document.getElementById('ta-comment').value
         document.getElementById('ta-comment').value = cmm + '@' + usersApp.value[index].arroba + ' '
         document.getElementById('ta-comment').focus()
         ///////    btn_out_offcanvas.value.click()
      }

      function getAllBoards(boardId, userId, contentId) {
         WspService.getAllBoards(boardId, userId, contentId)
         .then(response => {
            boards.value = response.data
            //console.log(response.data)
            /*
            nextTick(() => {
               selectBoardId.value = 0
               for (let key = 0; key < boards.value.length; key++) {
                  if (boards.value[key].selected) {
                     setEditValues(boards.value[key])
                     selectBoardId.value = boards.value[key].id
                  }
               }
            })
            nextTick(() => {
               getCellByContent(contentId, selectBoardId.value)
               getAllContent(contentId)
               getShowMoveShare( selectBoardId.value, contentId, cell.value.id )
            })
            */
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function getUsersBoard(board_id) {
         WspService.getBoardMembers(board_id)
         .then(response => {
            //usersBoard.value = response.data
            usersApp.value = response.data
            //console.log(response.data)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      /*
      function addMention() {       // creo que no se usa, chequear
         loading.value = true
         userIdsToAdd.value = []
         usersToAdd.value.forEach(function (user) {
            let addIndex = userIdsToAdd.value.length
            userIdsToAdd.value.splice(addIndex,0,user.id)
         });

            WspService.addMentionToCard(
               userIdsToAdd.value,
               cnttId.value,
               store.state.auth.user.id,     // userId,
               cellId.value
               )
            .then(() => {
               store.dispatch("wspace/setContentId", -9)
               focusOff()
            })
            .catch(error => {
               loading.value = false
               console.log(error);
            });
      }
      */
      function clearMember() {
         member.value = {
               name: '',
               arroba: ''
            }
      }

      function selectedBoard(index) {
         for (let i = 0; i < boards.value.length; i++) { 
            boards.value[i].selected = false
            if ( i == index ) {
               boards.value[i].selected = true
               getUsersBoard(boards.value[i].id)
            }
         }
      }
      /*
      function selectThisBoard() {
         if ( !thisBoard.value.selected ) {
            thisBoard.value.selected = true
            boardTo.value.selected = false
            arrobaDisable.value = false
            getUsersBoard(thisBoard.value.id)
         }
      }
      */
      function showAlias(index) {
         member.value = {
            name: usersApp.value[index].name,
            arroba: '@' + usersApp.value[index].arroba
         }
      }

      function focusOff() {
         /*
         setTimeout(
            document.getElementById('ta-comment').focus(),
             1000)
         */
         /*
         let timer = 1;
         let interval = setInterval(() => {
         if (timer === 0) {
            clearInterval(interval)                
         } else {
            timer--
            console.log(timer)
            loading.value = false
            btn_out_offcanvas.value.click()
            console.log(timer)
         }             
         }, 125)
         */
      }
  //onMounted(() => {
         //beforeUnmount() {
            /*
      beforeUnmount(() => {
            console.log('antes de salir del @')
      })
      */
      return {
         addMember,
         //addMention,
         boardId,
         boards,
         btn_out_offcanvas,
         cellId,
         cnttId,
         clearMember,
         focusOff,
         //getUsersBoard,
         loading,
         member,
         selectedBoard,
         showAlias,
         uAppIndex,
         uAppModule,
         usersApp,
         userId,
         userIdsToAdd,
         usersToAdd
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 150px;
  right: 100px;
  width: 350px;
  height: fit-content;
}
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-sm {
   width: max-content;
}
.fp-bg-color {
  width: 60px;
  height: 40px;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.user-member:hover {
   cursor: pointer;
}
.hg-mention {
   height: 60px;
}
.mb-scroll {
   max-height: calc(100vh - 130px);
   overflow: auto;
}
</style>